<style scoped>
    .vue-label {
        font-size: 9px;
        cursor: pointer;
        margin-right: 5px;
        word-wrap: normal;
        border-radius: 2px;
        position: relative;
        display: inline-block;
        padding: 2px 10px 2px 2px;
    }

    .vue-label::after {
        top: 1px;
        right: 3px;
        content: 'x';
        display: block;
        color: #f32c24;
        font-weight: bold;
        position: absolute;
    }
</style>

<template>
    <div>
        <div v-for="(condition, code) in conditions"
              class="label-default vue-label"
              @click="dropCondition(code)"
        >{{ condition.title }}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                conditions: [],
            };
        },
        created() {
            this.$root.$on('update-search-conditions', (conditions) => {
                this.conditions = conditions;
            });
        },
        methods: {
            dropCondition(code) {
                this.$root.$emit('clear-advanced-search-condition', code);
            }
        }
    }
</script>
